import React, { useState, useEffect } from "react";
import { Dropdown, Col } from "react-bootstrap";
import { Button } from "../../../../components/buttons";
import { signUp } from '../../../../store/action/auth'
import { saveTracking } from '../../../../store/action/tracking'
import { trackEvent, trackWithValue } from "../../../../services/analytics";

export default function ActionToConvert(props) {
    const initialState = {
        firstName:"",
        lastName:"",
        phone:"",
        email:"",
        password:""
    }
    const [ user, setUser ] = useState(initialState);
    const [ signup, setSignup ] = useState(true);
    const [ success, setSuccess ] = useState(false);
    const [ waybills, setWaybills ] = useState(false);
    const [ loading, setLoading ] = useState(false);
    
    useEffect(() => {
        const allWaybills = props.tracking.reduce((r,i) => {
            // only add waybill if its detected
            if (i.status) {
                r.push({
                    waybill_id:i.waybillId,
                    courier_code:i.courierCompany
                });
            }
            return r
        },[])
        setWaybills(allWaybills)
    },[props.tracking])
    
    const onSignUp = (event) => {
        setLoading(true);
        signUp({
            firstName:user.firstName, 
            lastName:user.lastName, 
            email:user.email, 
            phone:user.phone,
            password:user.password,
            source:`webAppTracking`
        })
        .then(data => {
          if (data.error) {
              alert(`Terjadi kesalahan. `+data.error);
              setUser(initialState)
          } else {
            onSaveTrackings(data.user_id);
            trackWithValue("User Sign Up Tracking",{
              action: "track",
              category: "Users",
              label: 'Sign Up From Tracking',
              event: "Click",
              value: 1000
            });
          }
          setLoading(false);
        })
    };
    
    const onSaveTrackings = (userId) => {
        try {
            setLoading(true);
            const data = {
                user_id:userId || null,
                user_name: `${user.firstName} ${user.lastName}`,
                phone:user.phone,
                email:user.email,
                waybills:waybills
            }
            saveTracking(data);
            trackWithValue("Monitor Courier Waybill", {
                action: "track",
                category: "Tools",
                label: "Monitor courier waybill from website",
                event: "Click",
                value: 500
            });
            setSuccess(true);
            setUser(initialState)
            setLoading(false);
        } catch (error) {
            console.log(error)
        }
       
    }

    if (success) {
        return (
            <div className="p-4 text-center">
                <i
                    className={"fas fa-check-circle fa-4x text-success"}
                />
                <h5>Resi Anda sudah berhasil didaftarkan ke Akun Anda</h5>
                <p>Biteship akan mengirimkan update pengiriman Anda ke nomor HP dan email lewat Akun Anda.</p>
                <Button
                    onClick={() => window.location.reload()}
                    className="btn btn-secondary border col-12 py-1 mt-2"
                >
                    Cek Resi Lagi
                </Button>
            </div>
        )
    }
    return (
        <div className="p-4">
            <h5>Monitor resi Anda secara real-time</h5>
            { 
                !signup ? 
                    <p>Masukkan email dan no HP Anda yang terdaftar di Biteship</p>
                    :
                    <p>Daftar agar Biteship bisa update resi Anda setiap ada perubahan status via chat atau email</p>
            }

            {
                signup ? 
                <div className="form-row">
                    <div className="form-group col-md-6">
                        <input
                            type="text"
                            onChange={e => setUser({...user,firstName:e.target.value})}
                            placeholder="Nama Depan"
                            className="form-control"
                            value={user.firstName}
                        />
                    </div>

                    <div className="form-group col-md-6">
                        <input
                            type="text"
                            onChange={e => setUser({...user,lastName:e.target.value})}
                            placeholder="Nama Belakang"
                            className="form-control"
                            value={user.lastName}
                        />
                    </div>
                </div>
                : null
            }
            
            <div className="form-group">
                <input
                    type="text"
                    onChange={e => setUser({...user,phone:e.target.value})}
                    placeholder="Nomor HP"
                    className="form-control"
                    value={user.phone}
                />
            </div>

            <div className="form-group">
                <input
                    type="text"
                    onChange={e => setUser({...user,email:e.target.value})}
                    placeholder="Email"
                    className="form-control"
                    value={user.email}
                />
            </div>
            
            { 
                signup ? 
                    <div>
                        

                        <div className="form-group">
                            <input
                                type="password"
                                onChange={e => setUser({...user,password:e.target.value})}
                                placeholder="Password"
                                className="form-control"
                                value={user.password}
                            />
                        </div>
                    </div>
                    :
                    null
            }
            
           
            <Button
                onClick={signup ? () => onSignUp() : () => onSaveTrackings()}
                className="btn btn-primary col-12 py-1"
                loading={loading}
            >
                Monitor Resi Saya
            </Button>
            <Button
                onClick={() => window.location.reload()}
                className="btn btn-secondary border col-12 py-1 mt-2"
            >
                Cek Resi Lagi
            </Button>

            { 
                signup ? 
                <p className="text-center mt-2">Sudah memiliki akun? Cukup Input no HP dan email <a className="text-primary pointer" onClick={() =>setSignup(!signup)}><b>disini!</b></a></p>
                :
                <p className="text-center mt-2">Belum punya akun? Daftar <a className="text-primary pointer" onClick={() =>setSignup(!signup)}><b>disini!</b></a></p>
            }
            
        </div>
    )
}
